export { type ISwitchProps } from '@rivallapp/native-base';
export { default } from './Switch';
